import type { KioskService } from './hooks';

const BODY_FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

interface Props {
  services: KioskService[];
  accentColor: string;
  showPrices: boolean;
  headingFont: string;
  isNewClient?: boolean;
  onSelect: (service: KioskService) => void;
}

export function KioskServicePicker({ services, accentColor, showPrices, headingFont, isNewClient = true, onSelect }: Props) {
  if (services.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 24px', fontFamily: BODY_FONT }}>
        <div style={{ fontSize: 16, color: '#636366' }}>This business hasn't set up their services yet</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '0 24px' }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: '#1A1A1A', fontFamily: headingFont, margin: '28px 0 16px' }}>
        What would you like?
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1, background: '#E5E5EA', borderRadius: 14, overflow: 'hidden' }}>
        {services.map(svc => (
          <button
            key={svc.id}
            onClick={() => onSelect(svc)}
            style={{
              background: '#fff', border: 'none', padding: '16px 18px', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              fontFamily: BODY_FONT, textAlign: 'left', transition: 'background 150ms ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = `${accentColor}0A`; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
          >
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 500, color: '#1A1A1A' }}>{svc.name}</div>
              {svc.description && <div style={{ fontSize: 13, color: '#636366', marginTop: 2 }}>{svc.description}</div>}
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: 16 }}>
              <div style={{ fontSize: 13, color: '#636366' }}>{svc.duration_minutes} min</div>
              {showPrices && svc.intro_enabled && svc.intro_price != null && isNewClient ? (
                <div>
                  <div style={{ fontSize: 10, fontWeight: 600, color: '#107C10', marginBottom: 2 }}>FIRST VISIT</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end' }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A' }}>${Number(svc.intro_price).toFixed(0)}</span>
                    <span style={{ fontSize: 12, color: '#ADB5BD', textDecoration: 'line-through' }}>${Number(svc.price).toFixed(0)}</span>
                  </div>
                  <div style={{ fontSize: 10, fontWeight: 600, color: '#107C10', marginTop: 1 }}>Save ${(svc.price - svc.intro_price).toFixed(0)}</div>
                </div>
              ) : (
                showPrices && <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A' }}>${Number(svc.price).toFixed(0)}</div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
